import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const TrendAnalysisInput = () => {
  const { trendId = '' } = useParams();
  const decodedId = trendId ? atob(trendId) : trendId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'trendAnalysis';

  useEffect(() => {
    if (trendId) { setIsEditing(true); fetchDetails(); }
  }, [trendId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['trendAnalysis'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Trend Analysis details:', error); }
  };

  const fields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'analysis_date', label: 'Analysis Date', type: 'date', required: true },
    { name: 'description', label: 'Description', type: 'textarea' }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Trend Analysis' : 'Create Trend Analysis'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/trend/list" />
    </div>
  );
};

export default TrendAnalysisInput;